import moment from "moment";

export const DATE_PRESET_CUSTOM = "custom";

export const RELATIVE_DATE_PRESETS = [
	{ id: "yesterday", label: "datePresets.yesterday" },
	{ id: "today", label: "datePresets.today" },
	{ id: "this_week", label: "datePresets.this_week" },
	{ id: "this_month", label: "datePresets.this_month" },
	{ id: "last_7_days", label: "datePresets.last_7_days" },
	{ id: "last_30_days", label: "datePresets.last_30_days" },
	{ id: "last_year", label: "datePresets.last_year" },
];

export function computeRelativeDateRange(presetId, now = moment()) {
	const n = moment(now);

	switch (presetId) {
		case "yesterday": {
			return {
				start: n.clone().subtract(1, "day").startOf("day"),
				end: n.clone().subtract(1, "day").startOf("day"),
			};
		}
		case "today": {
			return {
				start: n.clone().startOf("day"),
				end: n.clone().startOf("day"),
			};
		}
		case "this_week": {
			return {
				start: n.clone().startOf("isoWeek"),
				end: n.clone().endOf("isoWeek"),
			};
		}
		case "this_month": {
			return {
				start: n.clone().startOf("month"),
				end: n.clone().endOf("month"),
			};
		}
		case "last_7_days": {
			return {
				start: n.clone().subtract(6, "day").startOf("day"),
				end: n.clone().endOf("day"),
			};
		}
		case "last_30_days": {
			return {
				start: n.clone().subtract(29, "day").startOf("day"),
				end: n.clone().endOf("day"),
			};
		}
		case "last_year": {
			return {
				start: n.clone().subtract(1, "year").startOf("day"),
				end: n.clone().endOf("day"),
			};
		}
		case DATE_PRESET_CUSTOM:
		default:
			return null;
	}
}

